export type SanitizationConfig = {
  elements: string[];
  protocols: Record<string, any>;
  attributes: {
    __ALL__: string[];
  };
};

/* eslint-disable spellcheck/spell-checker */
export let config: SanitizationConfig = {
  elements: [
    'a',
    'abbr',
    'acronym',
    'address',
    'address',
    'applet',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'basefont',
    'bdi',
    'bdo',
    'bgsound',
    'big',
    'blink',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'content',
    'data',
    'datalist',
    'dd',
    'decorator',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'img',
    'input',
    'ins',
    'isindex',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'listing',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'nobr',
    'noframes',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'plaintext',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'section',
    'shadow',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'xmp',
  ],
  protocols: {
    form: {
      action: ['http', 'https', window.Sanitize.RELATIVE],
    },
    img: {
      src: ['http', 'https', window.Sanitize.RELATIVE],
    },
    a: {
      href: ['http', 'https', 'mailto', 'ftp', window.Sanitize.RELATIVE],
    },
  },
  attributes: {
    __ALL__: [
      'aLink',
      'abbr',
      'accept',
      'accessKey',
      'action',
      'align',
      'alinkColor',
      'allowTransparency',
      'alt',
      'async',
      'autocomplete',
      'autofocus',
      'axis',
      'background',
      'balance',
      'bgColor',
      'baseHref',
      'bgProperties',
      'border',
      'borderColor',
      'borderColorDark',
      'borderColorLight',
      'bottomMargin',
      'cellPadding',
      'cellSpacing',
      'cells',
      'ch',
      'chOff',
      'checked',
      'cite',
      'class',
      'classid',
      'clear',
      'codeBase',
      'codeType',
      'colSpan',
      'color',
      'cols',
      'compact',
      'content',
      'contenteditable',
      'contextmenu',
      'coords',
      'data',
      'dataset',
      'dataFld',
      'dataFormatAs',
      'dataPageSize',
      'dataSrc',
      'datetime',
      'declare',
      'defer',
      'dir',
      'disabled',
      'download',
      'draggable',
      'encoding',
      'enctype',
      'event',
      'face',
      'form',
      'formAction',
      'formEnctype',
      'formMethod',
      'for',
      'formNoValidate',
      'frame',
      'frameBorder',
      'frameSpacing',
      'headers',
      'height',
      'hidden',
      'hideFocus',
      'href',
      'hreflang',
      'hspace',
      'htmlFor',
      'hidden',
      'high',
      'href',
      'hreflang',
      'httpEquiv',
      'http-equiv',
      'icon',
      'id',
      'is',
      'ismap',
      'itemprop',
      'keytype',
      'kind',
      'label',
      'lang',
      'language',
      'leftMargin',
      'link',
      'list',
      'longDesc',
      'loop',
      'low',
      'lowsrc',
      'marginHeight',
      'marginWidth',
      'manifest',
      'max',
      'maxlength',
      'method',
      'methods',
      'media',
      'method',
      'min',
      'multiple',
      'name',
      'novalidate',
      'noValidate',
      'noHref',
      'noResize',
      'noShade',
      'noWrap',
      'open',
      'optimum',
      'pattern',
      'placeholder',
      'ping',
      'placeholder',
      'poster',
      'pluginspage',
      'preload',
      'pubdate',
      'radiogroup',
      'readonly',
      'rel',
      'required',
      'rev',
      'reversed',
      'rows',
      'rowspan',
      'rightMargin',
      'role',
      'rules',
      'sandbox',
      'scheme',
      'scope',
      'scoped',
      'scope',
      'scroll',
      'scrolling',
      'security',
      'seamless',
      'selected',
      'shape',
      'standby',
      'size',
      'sizes',
      'span',
      'spellcheck',
      'src',
      'srclang',
      'srcset',
      'start',
      'step',
      'style',
      'summary',
      'tabindex',
      'target',
      'text',
      'title',
      'type',
      'topMargin',
      'translate',
      'usemap',
      'units',
      'url',
      'urn',
      'usemap',
      'value',
      'valign',
      'valueType',
      'vcard',
      'version',
      'viewMasterTab',
      'volume',
      'vspace',
      'width',
      'wrap',
    ],
  },
};
